export default __webpack_public_path__ + "static/media/halfcircle.182906eb.svg";